"use strict";
// views/facturation/tvaCell.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ttcCell = exports.tvaCell = void 0;
const globals_1 = require("models/globals");
exports.tvaCell = [
    { template: "Totaux", type: "section" } //fillspace : true, height : 6}
    ,
    {
        cols: [
            { view: "label", label: (0, globals_1._)("Code TVA"), width: "70", align: "center", height: 20 },
            { view: "label", label: (0, globals_1._)("Libellé TVA"), maxWidth: "140", align: "center", height: 20 },
            { view: "label", label: (0, globals_1._)("Taux TVA %"), maxWidth: "110", align: "center", height: 20 },
            { view: "label", label: (0, globals_1._)("Total HT"), maxWidth: "140", align: "center", height: 20 },
            { view: "label", label: (0, globals_1._)("Montant TVA"), maxWidth: "140", align: "center", height: 20 }
        ],
    }, {
        cols: [
            { view: "text", localId: "codeTVA1", name: "codeTVA1", width: "70", readonly: true,
                inputAlign: "right" },
            { view: "text", localId: "libTVA1", name: "libTVA1", maxWidth: "140", readonly: true },
            { view: "text", localId: "tauxTVA1", name: "tauxTVA1", maxWidth: "110",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true },
            { view: "text", localId: "totalHT1", name: "totalHT1", maxWidth: "140",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true },
            { view: "text", localId: "montantTVA1", name: "montantTVA1", maxWidth: "140",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true }
        ]
    }, {
        cols: [
            { view: "text", localId: "codeTVA2", name: "codeTVA2", width: "70", readonly: true,
                inputAlign: "right" },
            { view: "text", localId: "libTVA2", name: "libTVA2", maxWidth: "140", readonly: true },
            { view: "text", localId: "tauxTVA2", name: "tauxTVA2", maxWidth: "110",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true },
            { view: "text", localId: "totalHT2", name: "totalHT2", maxWidth: "140",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true },
            { view: "text", localId: "montantTVA2", name: "montantTVA2", maxWidth: "140",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true }
        ]
    }, {
        cols: [
            { view: "text", localId: "codeTVA3", name: "codeTVA3", width: "70", readonly: true,
                inputAlign: "right" },
            { view: "text", localId: "libTVA3", name: "libTVA3", maxWidth: "140", readonly: true },
            { view: "text", localId: "tauxTVA3", name: "tauxTVA3", maxWidth: "110",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true },
            { view: "text", localId: "totalHT3", name: "totalHT3", maxWidth: "140",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true },
            { view: "text", localId: "montantTVA3", name: "montantTVA3", maxWidth: "140",
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true }
        ]
    }, {
        cols: [
            { view: "text", localId: "totalHT", name: "totalHT", label: (0, globals_1._)("Total HT"), width: "199",
                attributes: { maxlength: 12 }, tooltip: (0, globals_1._)("Total HT du document"),
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true, labelWidth: 78 },
            { view: "text", localId: "totalTVA", name: "totalTVA", label: (0, globals_1._)("Total TVA"), width: "199",
                attributes: { maxlength: 12 },
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true, labelWidth: 78 },
            { view: "text", localId: "totalTTC", name: "totalTTC", label: (0, globals_1._)("Total TTC"), width: "200",
                attributes: { maxlength: 12 }, tooltip: (0, globals_1._)("Total TTC "),
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true, labelWidth: 78 }
        ]
    }, { template: "", fillspace: true, height: 1 }
];
exports.ttcCell = [{
        cols: [
            {
                view: "text", localId: "totalTTC2", name: "totalTTC2", label: (0, globals_1._)("Total TTC"), width: "200",
                attributes: { maxlength: 12 }, tooltip: (0, globals_1._)("Total TTC "),
                format: globals_1.lv2.numberFormat, inputAlign: "right", readonly: true, labelWidth: 70
            },
            {
                view: "text",
                localId: "totalPrestations",
                name: "totalPrestations",
                label: (0, globals_1._)("Prestations"),
                width: "200",
                attributes: { maxlength: 12 },
                tooltip: (0, globals_1._)("Total prestations"),
                format: globals_1.lv2.numberFormat,
                inputAlign: "right",
                readonly: true,
                labelWidth: 90
            },
            {
                view: "text",
                localId: "totalFournitures",
                name: "totalFournitures",
                label: (0, globals_1._)("Fournitures"),
                width: "200",
                attributes: { maxlength: 12 },
                tooltip: (0, globals_1._)("Total fournitures"),
                format: globals_1.lv2.numberFormat,
                inputAlign: "right",
                readonly: true,
                labelWidth: 90
            }
        ]
    }];
